import styled from 'styled-components';

const InternalArea = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 30px 35px;
`;

export default InternalArea;